export default [
    'Decentralized News Source',
    'Group of Blockchain Enthusiasts',
    'Community Driven Forum',
    'Platform Against Censorship',
    'Source for Defi',
    'Global Community',
    'Hub for Information'
];